import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { LoadingOutlined, ArrowRightOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Row, Col, Tooltip, Card, Select, Modal, message, Upload, Input } from 'antd';
import { PaperClipOutlined } from '@ant-design/icons';
import ImageZoomAdmin from '../ImageZoomAdmin';
import FileConstants from '../../../../FileConstants';
import ENVIRONMENT from '../../../../environments';
import CustomerMainLayout from '../CustomerMainLayout/CustomerMainLayout';
import * as Constants from '../../CustomerComponents/Constants'
import axios from 'axios';
import { CustomImage } from '../../../Common/CustomImage/CustomImage';
import './MaterialQA.scss';
import SuccessModal from '../../SuccessModal/SuccessModal';
import { validateFileUploads } from '../../Utilities';

const MODEL_VIEWER_KEY = 'JKQ76HB9AB4HLNH8FK4';
const image_style = { width: '100%', height: "47.5vh", objectFit: "scale-down" };
const { Dragger } = Upload;
const { TextArea } = Input;

const MaterialQA = (props) => {
    const id = props.match.params.id;
    const [material, setMaterial] = useState(null);
    const [renders, setRenders] = useState([]);
    const [selectedImage, setSelectedImage] = useState('');
    const [renderedMaterial, setRenderedMaterial] = useState(false);
    const [nonRenderedMaterial, setNonRenderedMaterial] = useState(false);
    const [showInspector, setShowInspector] = useState(false);
    const [loading, setLoading] = useState(true);
    const [compareView, setCompareView] = useState(false);
    const [approveLoader, setApproveLoader] = useState(false);
    const [buttonLoader, setButtonLoader] = useState(false);
    const [rejectionMessage, setRejectionMessage] = useState("");
    const [attachments, setAttachments] = useState([]);
    const [rejectionError, setRejectionError] = useState("");
    const [uploadError, setUploadError] = useState("");
    const [rejectSuccess, setRejectSuccess] = useState(false);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [successModalVisible, setSuccessModalVisible] = useState(false);
    const [successModalMessage, setSuccessModalMessage] = useState("");
    const materialData = material;
    const handleChange = ({ fileList }) => setAttachments(fileList);
    const cancelRejectModal = () => setShowRejectModal(false);
    const writeMessage = (e) => setRejectionMessage(e.target.value);

    useEffect(() => {
        if (id) {
            axios.post(ENVIRONMENT.MATERIAL_GET, { material_id: id })
                .then(res => {
                    let mat = JSON.parse(res.data.body);
                    setMaterial(mat);
                    setLoading(false);
                })
                .catch(() => setLoading(false));
        }
    }, [id]);

    useEffect(() => {
        if (material) {
            let renderImages = [];
            if (material.renders && material.renders.data) {
                if (!FileConstants.AR_MATERIAL_OUTPUT_TYPES.includes(material.material_output)) {
                    setSelectedImage(material.renders.data && material.renders.data.thumbnail);
                }
                if (material.renders.data.artist_renders) {
                    renderImages = material.renders.data.artist_renders;
                } else if (material.renders.data.QA_renders) {
                    material.renders.data.QA_renders.map((render) => {
                        renderImages.push(render + '.jpg');
                    });
                }
                if (!renderImages.includes(material.renders.data.thumbnail)) {
                    renderImages.unshift(material.renders.data.thumbnail);
                }
                setRenders(renderImages);
            }
            if (FileConstants.AR_MATERIAL_OUTPUT_TYPES.includes(material.material_output)) {
                setNonRenderedMaterial(true);
                setShowInspector(true);
            }
            if (FileConstants.RENDERING_MATERIAL_OUTPUT_TYPES.includes(material.material_output)) {
                setRenderedMaterial(true);
            }
        }
    }, [material]);

    const handleApprove = () => {
        setApproveLoader(true);
        let payload = {
            material_id: material.id,
            status: "5",
            username: localStorage.getItem("username")
        }
        axios.post(ENVIRONMENT.UPDATE_MATERIAL, payload)
            .then(res => {
                setApproveLoader(false);
                setSuccessModalMessage('Material approved successfully!');
                setSuccessModalVisible(true);
            })
            .catch(err => {
                setApproveLoader(false);
                message.error('An error occurred. Unable to update material.');
            });
    };

    const rejectionAPICall = (payload_rejection, payload) => {
        axios.post(ENVIRONMENT.ENTITY_MODEL_REJECT, payload_rejection)
            .then(res => {
                axios.post(ENVIRONMENT.UPDATE_MATERIAL, payload)
                    .then(res => {
                        setShowRejectModal(false);
                        setButtonLoader(false);
                        setRejectSuccess(true);
                        setSuccessModalMessage('Material rejected successfully!');
                        setSuccessModalVisible(true);
                    }).catch(err => {
                        setButtonLoader(false);
                        message.error('An error occurred. Unable to update material.');
                    });
            }).catch(err => {
                setButtonLoader(false);
                message.error('An error occurred. Unable to reject material.');
            });
    };

    const rejectMaterial = () => {
        setRejectionError('');
        if (!rejectionMessage) {
            setRejectionError('Please enter a rejection message.');
            return;
        }
        let uploadAttachStatus = 'done';
        uploadAttachStatus = validateFileUploads(attachments);
        if (uploadAttachStatus === 'error') {
            setUploadError('An error occurred while uploading. Please try again.');
        } else if (uploadAttachStatus === 'uploading') {
            setUploadError('Please wait while uploads are in progress.');
        } else {
            setUploadError('');
            setButtonLoader(true);
            const payload = {
                material_id: material.id,
                status: "-4",
                admin_username: localStorage.getItem('username')
            };
            const payload_rejection = {
                material_id: material.id,
                message: rejectionMessage,
                reference_file: attachments,
                qa_person: localStorage.getItem('username'),
                artist: material.assigned_artist,
                qa_role: 'customer',
                rejection_against_artist: material.assigned_artist
            };
            rejectionAPICall(payload_rejection, payload);
        }
    };

    if (loading) {
        return <CustomerMainLayout selected='16'><div style={{ textAlign: 'center', marginTop: 100 }}><LoadingOutlined style={{ fontSize: 32 }} /></div></CustomerMainLayout>;
    }

    if (!material) {
        return <CustomerMainLayout selected='16'><div style={{ textAlign: 'center', marginTop: 100 }}>Material not found.</div></CustomerMainLayout>;
    }

    return (
        <CustomerMainLayout selected='16'>
            <div style={{ padding: '40px 40px 0 40px' }}>
                <Row style={{ justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
                    <Col span={20} className="materialqa-header-title">
                        <span className="manrope f-14 w-600">
                            <span className="store-bd" style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }} onClick={() => props.history.goBack()}>
                                <ArrowLeftOutlined style={{ marginRight: 6 }} /> Material QA
                            </span>
                            {material && material.name ? <span className="active-route-link-color">{' / ' + material.name}</span> : ''}
                        </span>
                    </Col>
                    <Col span={4} className="materialqa-header-btn-col">
                        {(material.status == 4 || material.status == 5) && !compareView && material.status == 4 &&
                            <div className="material-download-option customer" style={{ top: 50 }}>
                                <Button className="modal-okay square font-14" onClick={() => setCompareView(true)}>
                                    Comparison View <ArrowRightOutlined />
                                </Button>
                            </div>}
                        {(material.status == 4 || material.status == 5) && compareView && material.status == 4 &&
                            <div className="material-download-option customer" style={{ top: 50 }}>
                                <Button className="modal-okay square font-14" onClick={() => setCompareView(false)}>
                                    <ArrowLeftOutlined /> Back To Original View
                                </Button>
                            </div>}
                    </Col>
                </Row>
                <Row gutter={compareView ? 0 : 32} style={{ alignItems: 'stretch' }}>
                    <Col span={compareView ? 12 : 24} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                        <Card className="materialqa-card">
                            <Row>
                                <Col span={24} className="material-img-bg justify-in-center">
                                    {/* In the main viewer section, only show the comparison view toggle button when material.status == 4 */}
                                    {!showInspector && renderedMaterial && (material.status == 4 || material.status == 5) && material.renders && material.renders.data && material.renders.data.thumbnail ?
                                        <div className="room-viewer-normal" style={{ maxHeight: '47.5vh' }}>
                                            <ImageZoomAdmin custom_class={image_style} notShowToolButtons={true} material_modal={true} image={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.MATERIAL_FILE_URI + material.id + '/' + encodeURIComponent(selectedImage)} />
                                        </div>
                                        :
                                        !showInspector && material.material_files && Object.keys(material.material_files).length !== 0 && material.material_files[0] && !material.is_scanned && renderedMaterial ?
                                            <div className="room-viewer-normal" style={{ maxHeight: '47.5vh' }}>
                                                <ImageZoomAdmin custom_class={image_style} notShowToolButtons={true} material_modal={true} image={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(material.material_files[0].uid + '/' + material.material_files[0].name)} />
                                            </div>
                                            :
                                            null
                                    }
                                    {showInspector && nonRenderedMaterial && (material.status == 4 || material.status == 5) &&
                                        <iframe id='material-inspector-customer' onLoad={() => {
                                            document.getElementById('material-inspector-customer').contentWindow.postMessage({ model_viewer_key: MODEL_VIEWER_KEY, materialDebugMode: false }, '*');
                                        }} src={FileConstants.MaterialInspector + material.id} />
                                    }
                                    <div className="justify-space-between" style={{ padding: '0 3% 0 0', display: 'flex' }}>
                                        <div className="material-position">
                                            <div className="justify-in-start">
                                                {nonRenderedMaterial && (material.status == 4 || material.status == 5) &&
                                                    <Card style={{ marginLeft: 16, marginRight: 16, padding: 10, borderRadius: 4, cursor: 'pointer', textAlign: 'center', border: showInspector ? '1px solid #141414' : '1px solid #e4e4e4' }}
                                                        onClick={() => {
                                                            setSelectedImage('');
                                                            setShowInspector(true);
                                                            if (document.getElementById('material-inspector-customer') != null)
                                                                document.getElementById('material-inspector-customer').style.display = 'block';
                                                        }}
                                                    >
                                                        <img style={{ margin: 4 }} src={'/img/3d.jpg'} className="select-mat-small" />
                                                    </Card>
                                                }
                                                {renderedMaterial && renders.map((image, index) => (
                                                    <Card key={index} style={{ marginRight: 16, padding: 4, cursor: 'pointer', border: image === selectedImage ? '1px solid #141414' : '1px solid #e4e4e4', borderRadius: 4 }} onClick={() => {
                                                        setSelectedImage(image);
                                                        setShowInspector(false);
                                                    }}>
                                                        {!image.includes(FileConstants.THUMBNAIL_FILENAME) ? <div className="tag-bg"><span className="tag-txt">{FileConstants.MATERIAL_TYPE_LABELS_IMAGE[FileConstants.materialRenderTypeResolution(image)]}</span></div> : ''}
                                                        <img src={image.includes('.jpg') || image.includes('.png') || image.includes('.jpeg') ? ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.MATERIAL_FILE_URI + material.id + '/' + image : ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.MATERIAL_FILE_URI + material.id + '/' + image + '.jpg'} className="select-mat" />
                                                    </Card>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    {(material.status != 4 && material.status != 5) ?
                                        <div className="reject-admin-bg in-progress manrope f-16 white">In Progress Request</div> : ''}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                    {compareView && (
                        <Col span={12} style={{ display: 'flex', flexDirection: 'column' }}>
                            <Card className="room-viewer-normal" style={{ overflowY: 'hidden', height: '47.5vh', position: 'relative' }} bodyStyle={{ padding: 0, overflow: 'hidden', height: '100%' }}>
                                <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    {material && material.material_files && material.material_files.length > 0 && (
                                        <ImageZoomAdmin
                                            custom_class={image_style}
                                            compare={true}
                                            notShowToolButtons={true}
                                            image={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(material.material_files[0].uid + '/' + material.material_files[0].name)}
                                        />
                                    )}
                                </div>
                            </Card>
                        </Col>
                    )}
                </Row>
                {/* Move the details/text section here as a new Row below the main viewer/comparison Row */}
                <Row style={{ marginTop: 10 }} className="justify-space-between" gutter={[16]}>
                    <Col className="justify-in-start" span={8} style={{ flexWrap: 'wrap' }}>
                        <Tooltip title={<span className="manrope f-12 white">{material.name}</span>}>
                            <div className="manrope f-20 black-33 clamp-text w-50 capitalize" style={{ marginRight: "20px" }}>
                                <span style={{ marginRight: 5 }}>{material.name}</span>
                            </div>
                        </Tooltip>
                    </Col>
                </Row>
                <Row type="flex" style={{ justifyContent: "space-between", marginTop: "10px", alignItems: 'center' }}>
                    <Col span={18}>
                        <div className="justify-in-start" style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}>
                            <Col span={6} style={{ marginBottom: "10px" }}>
                                <div className="manrope f-12 grey-99" style={{ marginBottom: "4px", textAlign: "left" }}>Category</div>
                                <div className="manrope f-12 black-33 w-600">
                                    {material.category}
                                </div>
                            </Col>
                            <Col span={6} style={{ marginBottom: "10px" }}>
                                <div className="manrope f-12 grey-99" style={{ marginBottom: "4px", textAlign: "left" }}>Type</div>
                                <div className="manrope f-12 black-33 w-600">
                                    {material.type}
                                </div>
                            </Col>
                            <Col span={6} style={{ marginBottom: "10px" }}>
                                <div className="manrope f-12 grey-99" style={{ marginBottom: "4px", textAlign: "left" }}>Requirement</div>
                                <div className="manrope f-12 black-33 w-600">
                                    {FileConstants.MATERIAL_TYPE_LABELS[material.material_output]}
                                </div>
                            </Col>
                            {material.guidelines && material.guidelines != "" ?
                                <Col span={6} style={{ marginBottom: "10px" }}>
                                    <div className="manrope f-12 grey-99" style={{ marginBottom: "4px", textAlign: "left" }}>Guidelines/ Comments</div>
                                    {material.guidelines.split('\n').map((item, i) => {
                                        if (item === "") return null;
                                        return <div className="manrope f-12 black-33 w-600" style={{ textAlign: "left", marginBottom: 4 }} key={i}>{item}</div>
                                    })}
                                </Col> : ''}
                            {material.tags && material.tags.length > 0 ?
                                <Col span={6} style={{ marginBottom: "10px" }}>
                                    <div className="manrope f-12 grey-99" style={{ marginBottom: "4px", textAlign: "left" }}>Tags</div>
                                    <div className="manrope f-12 black-33 w-600">
                                        {material.tags.map((tag, index) => (
                                            <span className="manrope f-12 black-33 w-600" key={index}>
                                                {index > 0 ? `, ${tag}` : `${tag}`}
                                            </span>
                                        ))}
                                    </div>
                                </Col> : ''}
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row type="flex" style={{ justifyContent: "space-between", marginTop: "0px", alignItems: 'center' }}>
                    <Col span={16}>
                        <div className="justify-in-start" style={{ alignItems: 'flex-start' }}>
                            {material.material_files && Object.keys(material.material_files).length !== 0 && material.material_files.length > 0 ?
                                <span style={{ marginRight: 8 }}>
                                    <div className="manrope f-12 grey-77" style={{ marginTop: 10, marginBottom: 4 }}>Material Swatch</div>
                                    <Row>
                                        <Col className="justify-in-start">
                                            {!material.is_scanned ?
                                                material.material_files.map((file, index) => (
                                                    <Col style={{ paddingRight: 8 }} key={index}>
                                                        <Card bordered>
                                                            <CustomImage
                                                                className="rejected-mat"
                                                                src={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(file.uid + '/' + file.name)}
                                                                fileName={file.name}
                                                                style={{ width: 100, height: 100, objectFit: 'contain' }}
                                                            />
                                                        </Card>
                                                    </Col>
                                                ))
                                                :
                                                material.material_files.map((file, index) => (
                                                    <Col style={{ paddingRight: 8 }} key={index}>
                                                        <Card bordered>
                                                            <a href={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(file.uid + '/' + file.name)} target="_blank" rel="noopener noreferrer">
                                                                <Tooltip title={<span className='manrope f-12 white'>Click to View/Download</span>}>
                                                                    <img
                                                                        className="rejected-mat" src='/img/file-icon.png'
                                                                    />
                                                                </Tooltip>
                                                            </a>
                                                        </Card>
                                                    </Col>
                                                ))}
                                        </Col>
                                    </Row>
                                </span> : ''}
                            {material.reference_files && Object.keys(material.reference_files).length !== 0 && material.reference_files.length > 0 ?
                                <span>
                                    <div className="manrope f-12 grey-77" style={{ marginTop: 10, marginBottom: 4 }}>Reference Images</div>
                                    <Row>
                                        <Col className="justify-in-start">
                                            {material.reference_files && Object.keys(material.reference_files).length !== 0 && material.reference_files.length > 0 ?
                                                material.reference_files.map((file, index) => (
                                                    <Col style={{ paddingRight: 8 }} key={index}>
                                                        <Card bordered>
                                                            {file.name.includes('.zip') || file.name.includes('.mat') ?
                                                                <a href={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(file.uid + '/' + file.name)} target="_blank" rel="noopener noreferrer">
                                                                    <Tooltip title={<span className="manrope f-14 white">{file.name}</span>}>
                                                                        <img className="rejected-mat" src="/img/file-icon.png" />
                                                                    </Tooltip>
                                                                </a> :
                                                                <img
                                                                    className="rejected-mat" src={ENVIRONMENT.getBaseURL(material.platform) + ENVIRONMENT.BASE_URI + encodeURIComponent(file.uid + '/' + file.name)}
                                                                />}
                                                        </Card>
                                                    </Col>
                                                )) : ''}
                                        </Col>
                                    </Row>
                                </span> : ''}
                        </div>
                    </Col>

                </Row>
                {material.status == 4 && (
                    <Row type="flex">
                        {/* Spacer to prevent content from being hidden behind the sticky bar */}
                        <div style={{ height: 100 }} />
                        {/* Sticky bottom bar aligned with main content */}
                        <div
                            className='material-qa-review-bar white'
                        >
                            <Row className='justify-in-end'>
                                <Button
                                    className="outline-red-btn square font-14"
                                    disabled={false}
                                    type="default"
                                    onClick={() => setShowRejectModal(true)}
                                    shape="circle"
                                    size="large"
                                >
                                    Reject
                                </Button>
                                <Button
                                    className="modal-okay-green square font-14"
                                    type="danger"
                                    onClick={() => handleApprove()}
                                    style={{ marginLeft: "10px" }}
                                    shape="circle"
                                    size="large"
                                    disabled={approveLoader}
                                    loading={approveLoader}
                                >
                                    Approve
                                </Button>
                            </Row>
                        </div>
                    </Row>
                )}
            </div>

            <Modal
                visible={showRejectModal}
                onCancel={cancelRejectModal}
                destroyOnClose={true}
                maskClosable={false}
                className="aspect-ratio-modal small"
                footer={[
                    <span className="justify-in-end">
                        <Button disabled={buttonLoader} className="modal-okay-gray square font-14" onClick={() => setShowRejectModal(false)}>
                            Cancel
                        </Button>
                        <Button disabled={buttonLoader} className="modal-okay square font-14" htmlType="submit" onClick={rejectMaterial}>
                            Reject &nbsp;{buttonLoader ? <LoadingOutlined /> : ''}
                        </Button>
                    </span>
                ]}
            >
                <div style={{ padding: "32px 32px 24px 32px" }}>
                    <div className="manrope f-24 black-55" style={{ marginBottom: 24 }}>
                        Reject Material
                    </div>
                    <div className="justify-align-start">
                        <div style={{ width: "100%" }}>
                            <TextArea value={rejectionMessage} onChange={writeMessage} style={{ marginBottom: 8 }} className="manrope f-16 grey-77" placeholder="Please write a message for the artist specifying why you are rejecting this material" rows={6} />
                            {rejectionError == "" ? "" :
                                <div className="justify-space-between err-bg manrope f-12 red-error" style={{ marginRight: 8, marginBottom: 8 }}><img src="/img/error-small.png" style={{ marginRight: 8, marginBottom: 8 }} /><span>{rejectionError}</span></div>}
                            <Dragger className="material-reject-uploader"
                                listType="text"
                                fileList={attachments}
                                onChange={handleChange}
                                multiple={true}
                                onRemove={file => {
                                    setAttachments([]);
                                }}
                                progress={{
                                    strokeColor: {
                                        '0%': '#108ee9',
                                        '100%': '#87d068',
                                    },
                                    strokeWidth: 3,
                                    format: percent => `${parseFloat(percent.toFixed(2))}%`,
                                }}
                                {...Constants.getUploadProps(materialData && materialData.platform)}>
                                <p className="artist-upload-txt small"><PaperClipOutlined />&nbsp;Drop any attachments here, or <span style={{ color: "#276DD7" }}>Browse them</span>.</p>
                            </Dragger>
                        </div>
                    </div>
                    {uploadError == '' ? '' : <div className="err-bg manrope f-12 red-error" style={{ textAlign: "right", display: "flex", alignItems: "center", marginLeft: "auto", marginTop: 16 }}><img src="/img/error-small.png" style={{ marginRight: 8 }} /><span>{uploadError}</span></div>}
                </div>
            </Modal>
            <SuccessModal
                visible={successModalVisible}
                heading={successModalMessage}
                text={''}
                footer={[
                    <div className="justify-in-center">
                        <Button style={{ margin: "auto" }} className="modal-okay square font-14" htmlType="submit" onClick={() => props.history.goBack()}>
                            Okay
                        </Button>
                    </div>
                ]}
            />
        </CustomerMainLayout>
    );
};

export default withRouter(MaterialQA); 